module.exports = __webpack_public_path__ + "gy.svg?f1a8b3460583bf77661ae1996b472bda";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/gy.svg
// module id = 1076
// module chunks = 27